<template>
	<include-header-main />

	<section id="join_ok">
		<div class="join_inner">
			<div class="main_tit"><span>덴탈클라우드</span> <br class="mbr"> 임시회원 가입 완료</div>
			<div class="join_ok_txt">
				<div class="guide_icon"></div>
				<h5 class="guide_tit">관리자의 승인 후 로그인 가능합니다.</h5>
				<p class="guide_txt">승인 시 안내문자를 발송해 드리겠습니다.<br />감사합니다.</p>
			</div>
			<div class="main_btn btn_style1" @click="goto_logout">메인화면</div>
		</div>
	</section>

	<include-footer />
</template>

<script>
import header_main from '../components/layout/header-main.vue'
import footer from '../components/layout/footer.vue'

export default {
	name: 'App',
	components: {
		'include-header-main': header_main,
		'include-footer': footer
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as commonjs from '@/components/utils/common';
import * as globaljs from '@/components/utils/global';
import * as registerjs from '@/components/utils/register';

const route = useRoute();
const router = useRouter();

const goto_logout = () => {
	router.push('/?pre_page=reg_complete');
};
</script>